// Artwork exported from the Figma brief "NEW / Event Dashboard / From image brief" (3324:18828)
// on the PAVEL DRAFT page, downscaled from the source art to the sizes the screen draws them at.
// The SVARA PASS tile is still a dashed "ART" placeholder in the design, so the banner keeps
// reusing the VIP feature art until real artwork lands.
import BackArrowSvg from './back-arrow.svg';
import EventHeroBannerJpg from './hero-banner.jpg';
import RewardCardPurplePng from './reward-card-purple.png';
import RewardCardSpadePng from './reward-card-spade.png';
import RewardChestPng from './reward-chest.png';
import RewardChipPng from './reward-chip.png';
import RewardChipsRedPng from './reward-chips-red.png';
import RewardCoinsPng from './reward-coins.png';
import RewardGiftPng from './reward-gift.png';
import RewardTrophyPng from './reward-trophy.png';
import RewardTrophyGoldPng from './reward-trophy-gold.png';
import TabRewardsPng from './tab-rewards.png';
import TrackFreePng from './track-free.png';
import TrackPremiumPng from './track-premium.png';
import WalletBaseSvg from './wallet-base.svg';
import WalletPlusSvg from './wallet-plus.svg';

export {
	BackArrowSvg,
	EventHeroBannerJpg,
	RewardCardPurplePng,
	RewardCardSpadePng,
	RewardChestPng,
	RewardChipPng,
	RewardChipsRedPng,
	RewardCoinsPng,
	RewardGiftPng,
	RewardTrophyGoldPng,
	RewardTrophyPng,
	TabRewardsPng,
	TrackFreePng,
	TrackPremiumPng,
	WalletBaseSvg,
	WalletPlusSvg,
};
